<template>
  <div class="container">
    <DataLoader v-if="fetchLoading" :loading="fetchLoading" />
    <template v-else>
      <basic-edit-form :html-page="htmlPage" />
      <v-btn
        class="px-10 my-10 text-body-2 float-left"
        color="primary darken-1"
        min-height="50px"
        min-width="100px"
        tile
        dark
        depressed
        @click="updateHtmlPage"
      >
        保存
      </v-btn>
    </template>
  </div>
</template>

<script>
import DataLoader from '@/components/commons/DataLoader'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import BasicEditForm from './BasicEditForm'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    DataLoader,
    BasicEditForm
  },
  mixins: [headUtilsMixin],
  data () {
    return {
      pageTitle: 'HTMLページ基本設定',
      fetchLoading: true,
      htmlPage: {}
    }
  },
  async mounted () {
    this.fetchLoading = true
    await this.fetchHtmlPage()
    this.fetchLoading = false
  },
  methods: {
    fetchHtmlPage () {
      return axios
        .get(`/api/html_pages/${this.$route.params.id}`)
        .then(({ data }) => {
          this.htmlPage = deserialize(data).data
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    updateHtmlPage () {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .patch(`/api/html_pages/${this.$route.params.id}`, {
          html_page: this.htmlPage
        })
        .then(() => {
          const payload = {
            status: 200,
            message: '保存に成功しました。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.fetchHtmlPage()
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    }
  }
}
</script>
